// src/pages/Dashboard/Dashboard.js
import React from "react";
import "./Dashboard.css";

export default function Dashboard() {
  return (
    <div className="page-wrap">
      <h1>Welcome to Evallo HRMS</h1>
      <p>Use the left navigation to manage employees, teams and view logs.</p>
    </div>
  );
}
